import {FC} from 'react';
import {useFormContext} from 'react-hook-form';
import Button, {ButtonProps} from 'components/Button';

const SubmitButton: FC<ButtonProps> = ({
    children,
    disabled,
    onClick,
    ...rest
}) => {
    const {
        clearErrors,
        formState: {isSubmitting},
    } = useFormContext();

    return (
        <Button
            {...rest}
            disabled={isSubmitting || disabled}
            isLoading={isSubmitting}
            onClick={(event) => {
                clearErrors(['nonFieldErrors', 'successMessage']);
                onClick?.(event);
            }}
            type="submit"
        >
            {children}
        </Button>
    );
};

export default SubmitButton;
